export default function(value: any) {
  const a = "ñÑßÿœæŕŔřŘśŝŠńŃṕẃǵǹḿǘẍźḧ·"
  const b = "nNsyoarRrRsSnNpwgnmuxzh-"
  const p = new RegExp(a.split("").join("|"), "g")
  const result = value
    .toString()
    .trim()
    .replace(p, (c: any) => b.charAt(a.indexOf(c))) // Replace special chars

  return result
}
